import { render, staticRenderFns } from "./search.vue?vue&type=template&id=51427978&"
import script from "./search.vue?vue&type=script&lang=js&"
export * from "./search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\src\\KoRus.Nord\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51427978')) {
      api.createRecord('51427978', component.options)
    } else {
      api.reload('51427978', component.options)
    }
    module.hot.accept("./search.vue?vue&type=template&id=51427978&", function () {
      api.rerender('51427978', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Assets/Scripts/components/organisms/Header/search.vue"
export default component.exports